var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-wrapper tabs-wrapper-screen"},_vm._l((_vm.tabsList),function(item,index){return _c('Button',{key:index,staticClass:"tabs-item",attrs:{"type":"icon"},on:{"click":function($event){return _vm.handleTabs(item)}}},[_c('span',{staticClass:"tabs-icon-text"},[_vm._v(" "+_vm._s(_vm.tabsDic[item-1])+" ")]),_c('i',{class:[
        'tabs-icon-def',
        item === Number(_vm.currentIndex) ? 'tabs-icon-selected' : ''
      ]})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }